import { Map } from 'immutable'

export const SET_DETAIL_HERO = 'DETAIL_HERO_SET'
export const CLEAR_DETAIL_HERO = 'DETAIL_HERO_CLEAR'

export function setDetailHero (payload) {
  return { type: SET_DETAIL_HERO, payload }
}

export function clearDetailHero () {
  return { type: CLEAR_DETAIL_HERO }
}

export const initialState = Map()

export default function detailHeroReducer (state = initialState, action) {
  switch (action.type) {
    case SET_DETAIL_HERO:
      return Map.isMap(action.payload) ? action.payload : Map(action.payload)
    case CLEAR_DETAIL_HERO:
      return initialState
    default:
      return state
  }
}
